const TTL = 60 * 1000;
const MAX_ENTRIES = 80;
const entries = new Map();
let identity;
let generation = 0;

export function clearLibraryQueryCache() {
  generation += 1;
  entries.clear();
}

export function libraryQueryKey(url, config = {}) {
  const parsed = new URL(url, 'http://library.local');
  if (!/^\/(prompts|contexts|collections)(?:$|\/(?:user|used|favorites|drafts)$|\/collection\/[^/]+$)/.test(parsed.pathname)) return null;
  const params = new URLSearchParams(parsed.search);
  Object.entries(config.params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null) params.set(key, String(value));
  });
  params.delete('_t');
  params.sort();
  return `${parsed.pathname}?${params}`;
}

// Cache only list responses, never detail/permission checks or private data on disk.
export function installLibraryQueryCache(api, getIdentity) {
  const get = api.get.bind(api);
  api.get = async (url, config = {}) => {
    const nextIdentity = getIdentity();
    if (nextIdentity !== identity) {
      clearLibraryQueryCache();
      identity = nextIdentity;
    }
    const key = libraryQueryKey(url, config);
    if (!key || !nextIdentity || config.signal) return get(url, config);
    if (config.libraryForceRefresh) entries.delete(key);
    let entry = entries.get(key);
    if (!entry || entry.expires <= Date.now()) {
      const currentGeneration = generation;
      entry = { expires: Date.now() + TTL };
      entry.promise = get(url, config).then((response) => ({ data: response.data, status: response.status, statusText: response.statusText, headers: response.headers }), (error) => {
        if (currentGeneration === generation && entries.get(key) === entry) entries.delete(key);
        throw error;
      });
      if (entries.size >= MAX_ENTRIES) entries.delete(entries.keys().next().value);
      entries.set(key, entry);
    }
    const response = await entry.promise;
    return { ...response, config, data: JSON.parse(JSON.stringify(response.data)) };
  };
}

export function invalidateLibraryMutation(method, url = '') {
  if (['post', 'put', 'patch', 'delete'].includes(method?.toLowerCase()) && /^\/(prompts|contexts|collections|starter-pack|auth|groups|teams|users|invitations|interactions\/uses)(?:\/|$)/.test(url)) {
    clearLibraryQueryCache();
  }
}
